// eslint-disable-next-line import/no-anonymous-default-export
export default {
    SET_AUTHENTICATED_USER: "SET_AUTHENTICATED_USER",
    RESET_AUTHENTICATED_USER: "RESET_AUTHENTICATED_USER"
  };
  